//Category images
import accidentImage from '../../assets/landing/accident-and-injury.jpg';
import consumerImage from '../../assets/landing/consumer_law.jpg';
import crimeImage from '../../assets/landing/criminal_law.jpg';
import employmentImage from '../../assets/landing/employment_law.jpg';
import familyImage from '../../assets/landing/family_law.jpg';
import propertyImage from '../../assets/landing/property_law.jpeg';
import immigrationImage from '../../assets/landing/immigration_law.jpeg';
import debtImage from '../../assets/landing/debt_collection_law.jpg';
import welfareImage from '../../assets/landing/social_welfare_lawyer.jpeg';

//Partner logos
import abcLogo from '../../assets/landing/abc_australia_logo.png';
import businessInsiderLogo from '../../assets/landing/business_insider_logo.png';
import dailyMailLogo from '../../assets/landing/daily_mail.png';
import newsComAuLogo from '../../assets/landing/news_com_au.png';
import smartCompanyLogo from '../../assets/landing/smart_company_logo.png';

//Job type images
import consultationImage from '../../assets/landing/get_consultation.jpg';
import sendLegalClaimImage from '../../assets/landing/send_legal_claim.jpg';
import fileLegalClaimImage from '../../assets/landing/file_legal_claim.jpg';
import defendLegalClaimImage from '../../assets/landing/defend_legal_claim.jpg';
import representationImage from '../../assets/landing/representation.jpg';
import publicNotaryImage from '../../assets/landing/public_notary.jpg';

//testimonial images
import sharonImage from '../../assets/landing/testimonial_sharon_g.png';
import jeremiahImage from '../../assets/landing/testimonial_jeremiah.png';
import jasonImage from '../../assets/landing/testimonial_jason.png';

export const categoryItems = [
  {
    label: 'Accident & Injury',
    key: 'accident-and-injury',
    image: accidentImage,
  },
  {
    label: 'Consumer and civil rights',
    key: 'consumer-and-civil-rights',
    image: consumerImage,
  },
  {
    label: 'Crime',
    key: 'crime',
    image: crimeImage,
  },
  {
    label: 'Employment',
    key: 'employment',
    image: employmentImage,
  },
  {
    label: 'Family and relationships',
    key: 'family-and-relationships',
    image: familyImage,
  },
  {
    label: 'Houses, property and neighbours',
    key: 'houses-property-and-neighbours',
    image: propertyImage,
  },
  {
    label: 'Immigration and changing countries',
    key: 'immigration-changing-countries',
    image: immigrationImage,
  },
  {
    label: 'Money and debt',
    key: 'money-and-debt',
    image: debtImage,
  },
  {
    label: 'Social welfare, health and benefits',
    key: 'social-welfare-health-benefits',
    image: welfareImage,
  },
];

export const partnerItems = [
  {
    key: 'abc-australia',
    alt: 'Logo of ABC Australia',
    image: abcLogo,
  },
  {
    key: 'business-insider',
    alt: 'Logo of Business Insider',
    image: businessInsiderLogo,
  },
  {
    key: 'daily-mail',
    alt: 'Logo of Daily Mail Australia',
    image: dailyMailLogo,
  },
  {
    key: 'news-com-au',
    alt: 'Logo of News com au',
    image: newsComAuLogo,
  },
  {
    key: 'smart-company',
    alt: 'Logo of Smart Company',
    image: smartCompanyLogo,
  },
];

export const jobTypeItems = [
  {
    label: 'Get consultation and advice',
    key: 'get-consultation-and-advice',
    image: consultationImage,
  },
  {
    label: 'Send a legal letter',
    key: 'send-a-legal-letter',
    image: sendLegalClaimImage,
  },
  {
    label: 'File a legal claim',
    key: 'file-a-legal-claim',
    image: fileLegalClaimImage,
  },
  {
    label: 'Defend a legal claim',
    key: 'defend-a-legal-claim',
    image: defendLegalClaimImage,
  },
  {
    label: 'Representation at court',
    key: 'representation-at-court',
    image: representationImage,
  },
  {
    label: 'Notary public services',
    key: 'notary-public-services',
    image: publicNotaryImage,
  },
];

export const testimonialItems = [
  {
    key: 'sharon-n',
    content:
      'I was struggling to generate leads for my business until I found Legalfinda. Their team is quick, professional, and always willing to go the extra mile to ensure that their clients are satisfied. Thanks to their services, I have been able to grow my business and reach new heights.',
    author: 'Sharon N',
    job: 'Principal Lawyer',
    image: sharonImage,
  },
  {
    key: 'jeremiah-d',
    content:
      'I have been using LegalFinda for a while now and I am impressed with their services. They have helped us generate high-quality clients that have resulted in increased sales and revenue for our business. Their team is responsive, reliable. I highly recommend to anyone who is looking to reliably increase their billable hours.',
    author: 'Jeremiah D',
    job: 'Practice Manager',
    image: jeremiahImage,
  },
  {
    key: 'jason-g',
    content:
      'More Billable Hours- I was trying to climb the ranks as an associate, and hopefully one day become partner for my law firm. I was skeptical about using a marketing service at first, but LegalFinda has exceeded my expectations. Their team delivers quality clients that you can choose based on location. Thanks to their services, I have been able to set up my own business and grow my business quickly. Happy customer',
    author: 'Jason G',
    job: 'Principal Lawyer',
    image: jasonImage,
  },
];

export const discoverColumns = [
  {
    key: 'sydney',
    title: '1. Sydney',
    address: 'Sydney, New South Wales, Australia',
    bounds: '-33.5626443,151.3698841,-34.1171753,150.5209341',
    content: [
      { label: 'Conveyancing', key: 'conveyancing' },
      { label: 'Civil and Criminal Law', key: 'consumer-and-civil-rights', searchable: true },
      { label: 'Family Law', key: 'family-and-relationships', searchable: true },
      { label: 'Commercial Law', key: 'commercial-law' },
      { label: 'Employment Law', key: 'employment', searchable: true },
    ],
  },
  {
    key: 'melbourne',
    title: '2. Melbourne',
    address: 'Melbourne, Victoria, Australia',
    bounds: '-37.5021098,145.5506999,-38.4514553,144.5589528',
    content: [
      { label: 'Property Law', key: 'houses-property-and-neighbours', searchable: true },
      { label: 'Immigration Law', key: 'immigration-changing-countries', searchable: true },
      { label: 'Family Law', key: 'family-and-relationships', searchable: true },
      { label: 'Taxation Law', key: 'taxation-law' },
      { label: 'Employment Law', key: 'employment', searchable: true },
    ],
  },
  {
    key: 'brisbane-gold-coast',
    title: '3. Brisbane/Gold Coast',
    address: 'Brisbane, Queensland, Australia',
    bounds: '-26.9631804,153.3316532,-27.7789194,152.667538',
    content: [
      { label: 'Conveyancing', key: 'conveyancing' },
      { label: 'Civil and Criminal Law', key: 'consumer-and-civil-rights', searchable: true },
      { label: 'Commercial Law', key: 'commercial-law' },
      { label: 'Employment Law', key: 'employment', searchable: true },
      { label: 'Compensation Law', key: 'compensation-law' },
    ],
  },
  {
    key: 'adelaide',
    title: '4. Adelaide',
    address: 'Adelaide, South Australia, Australia',
    bounds: '-34.6477945,138.7729485,-35.3489565,138.4151998',
    content: [
      { label: 'Conveyancing', key: 'conveyancing' },
      { label: 'Civil and Criminal Law', key: 'consumer-and-civil-rights', searchable: true },
      { label: 'Family Law', key: 'family-and-relationships', searchable: true },
      { label: 'Commercial Law', key: 'commercial-law' },
      { label: 'Employment Law', key: 'employment', searchable: true },
    ],
  },
  {
    key: 'perth',
    title: '5. Perth',
    address: 'Perth, Western Australia, Australia',
    bounds: '-31.5686816,116.3237502,-32.6594946,115.5890163',
    content: [
      { label: 'Property Law', key: 'houses-property-and-neighbours', searchable: true },
      { label: 'Immigration Law', key: 'immigration-changing-countries', searchable: true },
      { label: 'Family Law', key: 'family-and-relationships', searchable: true },
      { label: 'Taxation Law', key: 'taxation-law' },
      { label: 'Employment Law', key: 'employment', searchable: true },
    ],
  },
];
